import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SideMenu from "../../Components/SideMenu";
import { Button } from "react-bootstrap";
import { addVideo, deleteBanner, getBanners, updateVideo, videoDelete, videoList } from "../../reducers/commonReducer";
import { handleContextMenu, home } from "../../const";
import VideoAction from "./VideoAction";
import { getCategoriesFrontEnd } from "../../reducers/frontEndReducer";

const Video = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (localStorage.getItem("slug") === "admin" ? !localStorage.getItem("x-admin-token") : !localStorage.getItem("x-auth-token")) {
      navigate(home);
    }
    dispatch(videoList());
    dispatch(getCategoriesFrontEnd());
  }, []);

  const { videoListData } = useSelector((state) => state.commonReducer);
  return (
    <>
      <SideMenu />
      <div className="mt-extra content container-fluid">
        <div className="m-2">
          <VideoAction api={addVideo} buttonTitle = {"Add Video"}/>
        </div>

        <table className="table table-scrolling ">
          <thead className="normalplace">
            <tr className="tables">
              <th className="over-col-size">Sr</th>
              <th className="over-col-size">Title</th>
              <th className="over-col-size">Orderby</th>
              <th className="over-col-size">Category</th>
              <th className="over-col-size">Video</th>
              <th className="over-col-size">Status</th>
              <th className="over-col-size">Action</th>
            </tr>
          </thead>
          <tbody className="tbody-table">
            {!!videoListData?.list &&
              videoListData?.list.map((data, index) => {
                return (
                  <tr key={index}>
                    <td>{index + 1}.</td>
                    <td>{data?.title}</td>
                    <td>{data?.orderby}</td>
                    <td>{data?.category ? data?.category.name : "All"}</td>
                    <td>
                    <iframe
                        src={data?.video}
                        title={data?.title}
                        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    </td>
                    <td>
                      <b>{data?.status === true ?<span className="text-white bg-success rounded px-2 f-13">True</span> : <span className="text-white bg-danger rounded px-2 f-13">False</span>}</b>
                    </td>
                    <td>
                      <VideoAction
                        buttonTitle="Update Video"
                        title={data?.title}
                        category={data?.category?.id}
                        video={data?.video}
                        status={data?.status}
                        id={data?.id}
                        videoType={data.videoType}
                        orderby={data?.orderby}
                        api={updateVideo}
                      />
                      <Button
                        className="m-1"
                        variant="danger"
                        onClick={async () => {
                          const apiResp = await dispatch(videoDelete({id: data?.id}));
                          if(apiResp?.payload?.status){
                            await dispatch(videoList());
                          }
                        }}
                      >
                        <i className="bi bi-trash"></i>
                      </Button>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Video;
